import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Typography, Spin, Button, Tabs } from "antd";
import DOMPurify from "dompurify";
import axios from "axios";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import { ArrowLeftOutlined } from "@ant-design/icons";
import lang from "../helper/lang";
const { Title, Paragraph } = Typography;

const ViewEmail = () => {
  const { id } = useParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { request } = useRequest();
  const currentYear = new Date().getFullYear();

  const handleBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);

      request({
        url: `/admin/email/${id}`,
        method: "GET",
        onSuccess: (data) => {
          setContent(data.data);
          setLoading(false);
        },
        onError: (error) => {
          console.error("Failed to fetch content:", error);
          ShowToast(error, Severty.ERROR);
          setLoading(false);
        },
      });
    };

    fetchContent();
  }, [id]);

  if (loading) return <Spin />;

  if (!content) return <p>Content not found.</p>;

  return (
    <>
      <div className="back-box-btn">
        <Button onClick={handleBack} className="back-button mb-2">
          <ArrowLeftOutlined /> {lang("Back")}
        </Button>
      </div>
      <Card title="View Email Template">
        <Tabs defaultActiveKey="english">
          {[
            {
              key: "english",
              label: "English",
              subject: "subject",
              body: "body",
              title: "title",
              desc: "description",
            },
            {
              key: "arabic",
              label: "Arabic",
              subject: "ar_subject",
              body: "ar_body",
              title: "ar_title",
              desc: "ar_description",
            },
            {
              key: "french",
              label: "French",
              subject: "fr_subject",
              body: "fr_body",
              title: "fr_title",
              desc: "fr_description",
            },
            {
              key: "dutch",
              label: "Dutch",
              subject: "nl_subject",
              body: "nl_body",
              title: "nl_title",
              desc: "nl_description",
            },
            {
              key: "thai",
              label: "Thai",
              subject: "th_subject",
              body: "th_body",
              title: "th_title",
              desc: "th_description",
            },
            {
              key: "portuguese_brazil",
              label: "Portuguese (Brazil)",
              subject: "pt_br_subject",
              body: "pt_br_body",
              title: "pt_br_title",
              desc: "pt_br_description",
            },
            {
              key: "portuguese_portugal",
              label: "Portuguese (Portugal)",
              subject: "pt_pt_subject",
              body: "pt_pt_body",
              title: "pt_pt_title",
              desc: "pt_pt_description",
            },
            {
              key: "polish",
              label: "Polish",
              subject: "pl_subject",
              body: "pl_body",
              title: "pl_title",
              desc: "pl_description",
            },
            {
              key: "vietnamese",
              label: "Vietnamese",
              subject: "vi_subject",
              body: "vi_body",
              title: "vi_title",
              desc: "vi_description",
            },
            {
              key: "russian",
              label: "Russian",
              subject: "ru_subject",
              body: "ru_body",
              title: "ru_title",
              desc: "ru_description",
            },
            {
              key: "korean",
              label: "Korean",
              subject: "ko_subject",
              body: "ko_body",
              title: "ko_title",
              desc: "ko_description",
            },
            {
              key: "spanish",
              label: "Spanish",
              subject: "es_subject",
              body: "es_body",
              title: "es_title",
              desc: "es_description",
            },
            {
              key: "traditional_chinese_taiwan",
              label: "Traditional Chinese (Taiwan)",
              subject: "zh_tw_subject",
              body: "zh_tw_body",
              title: "zh_tw_title",
              desc: "zh_tw_description",
            },
            {
              key: "traditional_chinese_hongkong",
              label: "Traditional Chinese (Hong Kong)",
              subject: "zh_hk_subject",
              body: "zh_hk_body",
              title: "zh_hk_title",
              desc: "zh_hk_description",
            },
            {
              key: "simplified_chinese",
              label: "Simplified Chinese",
              subject: "zh_cn_subject",
              body: "zh_cn_body",
              title: "zh_cn_title",
              desc: "zh_cn_description",
            },
          ].map((lang) => (
            <Tabs.TabPane tab={lang.label} key={lang.key}>
              <Title level={4}>Subject: {content[lang.subject]}</Title>
              <div style={{ margin: 0, fontFamily: "'Poppins', sans-serif" }}>
                <link
                  href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap"
                  rel="stylesheet"
                />
                <table
                  style={{
                    borderCollapse: "collapse",
                    padding: 0,
                    margin: "0 auto",
                    fontSize: "17px",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  width="600px"
                  bgcolor="#E7EDFE"
                >
                  <thead>
                    <tr>
                      <td
                        style={{
                          padding: "20px 30px 20px",
                          background: "#323439",
                        }}
                      >
                        <a href="#" style={{ padding: "20px 30px 20px" }}>
                          <img
                            style={{ filter: "invert(1)" }}
                            src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/realState/adminTeam%20Intelligence%20Hub.5f45cf03829eda53eba25f5bd330a553%201.png"
                            alt="Logo"
                          />
                        </a>
                      </td>
                    </tr>
                  </thead>

                  <tbody style={{ background: "#fff" }}>
                    <tr>
                      <td
                        style={{
                          padding: "50px 30px",
                          border: "solid 1px #f7f7f7",
                        }}
                      >
                        <img
                          src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/realState/adminGroup%201686556552.png"
                          style={{ maxWidth: "150px" }}
                          alt="Icon"
                        />

                        <h3
                          style={{
                            margin: "30px auto 15px",
                            fontSize: "20px",
                            textTransform: "uppercase",
                            color: "#383838",
                            maxWidth: "70%",
                            fontWeight: 700,
                            lineHeight: 1.2,
                          }}
                        >
                          {content[lang.title]}
                        </h3>
                        <p
                          style={{
                            margin: "15px auto",
                            fontSize: "16px",
                            color: "#666",
                          }}
                        >
                          {content[lang.desc]}
                        </p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              content[lang.body] || content[lang.desc] || ""
                            ),
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td
                        style={{
                          padding: "30px",
                          fontSize: "14px",
                          background: "#323439",
                          color: "white",
                        }}
                      >
                        Copyright © {currentYear} TEAM.AS.ONE . All rights reserved.
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </Tabs.TabPane>
          ))}
        </Tabs>
      </Card>
    </>
  );
};

export default ViewEmail;